import { render } from "./PressRelease.vue?vue&type=template&id=0884e80a&scoped=true"
import script from "./PressRelease.vue?vue&type=script&lang=js"
export * from "./PressRelease.vue?vue&type=script&lang=js"

import "./PressRelease.vue?vue&type=style&index=0&id=0884e80a&lang=scss&scoped=true"

import exportComponent from "/Users/skynet/Documents/Sites Safe OK MAIS PEUT ETRE PAS A JOUR/Safe_Sites_Modifs/SAFE_BO/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0884e80a"]])

export default __exports__